import {
  defFetchList,
  defFetchOne,
  defCreate,
  defUpdateOne,
  defDeleteOne,
  defUploadCoverImage
} from '@/api/default'

const BASE_PATH = '/blog_category'

export function fetchList (query) {
  return defFetchList(BASE_PATH, query)
}

export function fetchOne (id) {
  return defFetchOne(BASE_PATH, id)
}

export function create (data) {
  return defCreate(BASE_PATH, data)
}

export function updateOne (id, data) {
  return defUpdateOne(BASE_PATH, id, data)
}

export function deleteOne (id) {
  return defDeleteOne(BASE_PATH, id)
}

export function uploadCoverImage (id, data, config) {
  return defUploadCoverImage(BASE_PATH, id, data, config)
}
